module.exports = __webpack_public_path__ + "img/cloth_g1_pants_03.55aec7c6.svg";